import styled from 'styled-components';
import AppBar from '@material-ui/core/AppBar';

export const AppBarStyled = styled(AppBar)`
  && {
    background-color: #f3f6f9;
    box-shadow: none;
    margin-top: -20px;
    padding: 4px 0 16px;
    z-index: 100;
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 24px;
  line-height: 36px;
  font-weight: 400;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
